import React, { useRef, useEffect, useState, useContext } from 'react';
import './style.css';
import axios from 'axios';
import { decompressData } from '/src/utils/decompressData';
import UpdateMenu from './Menu/UpdateMenu';
import Sidebar from './Sidebar/Sidebar';
import PropertySubmenu from './PropertySubmenu/PropertySubmenu';
import InputsDisplay from './InputsDisplay/InputsDisplay';
import ChangeLog from './ChangeLog/ChangeLog';
import { CircleX } from 'lucide-react';
import { AddressSearchContext } from '/src/App';
// import DatapointInput from './DatapointInput/DatapointInput';
// import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';

const UpdateDataModule = ({ propertyData, setPropertyData, setShowUpdateModal, setUpdateStatus, setShowProcessingModal, setProcessingComplete }) => {
    
    // Get the portalData from the AddressSearchContext
    const { portalData } = useContext(AddressSearchContext);

    const modalRef = useRef(null);
    const [selectedSection, setSelectedSection] = useState(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [selectedHomeSection, setSelectedHomeSection] = useState(null);
    const [updatedDatapoints, setUpdatedDatapoints] = useState([]);
    const [processingStatus, setProcessingStatus] = useState(false);
    const [updatedCompletedProjects, setUpdatedCompletedProjects] = useState([]);

    // Get the property_id from the propertyData
    const property_id = propertyData.address_id;

    // Load the initial data
    const datapoints = portalData.datapoints || {};
    const house_categories = portalData.houseCategories || {};
    const icons = portalData.icons || {};
    const user_datapoints = propertyData.data.user_input_form;

    // Filter the datapoints to only include ones where the value of user_input is true
    const filtered_datapoints = datapoints.filter(datapoint => datapoint.user_input === true);

    // Get the projects
    const projects = propertyData?.data?.recommended_projects?.projects_list;

    // Get the change log from the saved property data in user local storage
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const savedProperty = user.purchased_addresses?.find(addr => addr.address_id === property_id);
    const changeLog = savedProperty?.change_log || [];

    // Merge user_datapoints values into datapoints array and add datapoint_value_updated
    const mergedDatapoints = filtered_datapoints.map(datapoint => {
        const userDatapoint = user_datapoints.find(udp => udp.id === datapoint.id);
        let value = userDatapoint ? userDatapoint.datapoint_value : null;

        if (value !== null && datapoint.data_type === 'num' && datapoint.num_type.startsWith('int')) {
            value = Math.ceil(Number(value));
        }

        return {
            ...datapoint,
            datapoint_value: value,
            datapoint_value_updated: null,
            type_for_user_form: 'datapoint'
        };
    });


    // Enrich datapoints with house_categories and icons information
    const enrichedDatapoints = mergedDatapoints.map(datapoint => {
        const associatedHome = datapoint.associated_house;
        if (associatedHome && house_categories[associatedHome]) {
            const category = house_categories[associatedHome];
            return {
                ...datapoint,
                associated_home_name: category.category,
                associated_home_icon: icons[category.icon] || '',
                associated_home_image: icons[category.image] || ''
            };
        }
        return datapoint;
    });

    // Add type to projects
    const enrichedProjects = projects.map(project => ({
        ...project,
        type_for_user_form: 'project'
    }));

    // // Categorize the enriched datapoints
    // const homeCharacteristics = enrichedDatapoints.filter(point =>
    //     point.user_input === true &&
    //     point.checklist_item === false &&
    //     point.form_category === "house"
    // );


    // Property --> House --> Characteristics / Structure

    const property_house_characteristics_structure = enrichedDatapoints.filter(point => point.portal_form_category === "property_house_characteristics_structure");

    // Property --> House --> Materials
    const property_house_materials = enrichedDatapoints.filter(point => point.portal_form_category === "property_house_materials");

    // Property --> House --> Equipment
    const property_house_equipment = enrichedDatapoints.filter(point => point.portal_form_category === "property_house_equipment");

    // Property --> House --> Conditions
    const property_house_conditions = enrichedDatapoints.filter(point => point.portal_form_category === "property_house_conditions");

    // Property --> Experience --> History
    const property_house_history = enrichedDatapoints.filter(point => point.portal_form_category === "property_experience_history");

    // Property --> Experience --> Maintenance
    const property_house_maintenance = enrichedDatapoints.filter(point => point.portal_form_category === "property_experience_maintenance");

    // Property --> Experience --> Use
    const property_house_use = enrichedDatapoints.filter(point => point.portal_form_category === "property_experience_use");

    // Financial --> Area Economics
    const financial_area_economics = enrichedDatapoints.filter(point => point.portal_form_category === "financial_area_economics");

    // Financial --> Current Costs
    const financial_current_costs = enrichedDatapoints.filter(point => point.portal_form_category === "financial_current_costs");

    // Financial --> Housing Market
    const financial_housing_market = enrichedDatapoints.filter(point => point.portal_form_category === "financial_housing_mkt");

    // const inspectionFindings = enrichedDatapoints.filter(point =>
    //     point.user_input === true &&
    //     point.checklist_item === true &&
    //     point.checklist_category === "inspection"
    // );

    // const homeExperiences = enrichedDatapoints.filter(point =>
    //     point.user_input === true &&
    //     point.checklist_item === true &&
    //     point.checklist_category === "experience"
    // );

    // const financialInputs = enrichedDatapoints.filter(point =>
    //     point.user_input === true &&
    //     point.checklist_item === false &&
    //     point.form_category === "financial"
    // );


    // const menuSections = [
    //     {
    //         id: 'property',
    //         title: 'About the Property',
    //         icon: 'resilience-projects-dark-gray.png',
    //         options: [
    //             { id: 'details', label: 'Property Details', data: homeCharacteristics },
    //             { id: 'condition', label: 'Current Condition', data: inspectionFindings },
    //             { id: 'historical', label: 'Historical Events', data: homeExperiences }
    //         ]
    //     },
    //     {
    //         id: 'financial',
    //         title: 'Financial Details',
    //         icon: 'resilience-projects-dark-gray.png',
    //         options: [
    //             { id: 'costs', label: 'Costs and Assumptions', data: financialInputs }
    //         ]
    //     },
    //     {
    //         id: 'resilience',
    //         title: 'Resilience',
    //         icon: 'resilience-projects-dark-gray.png',
    //         options: [
    //             { id: 'completed', label: 'Completed Projects', data: enrichedProjects }
    //         ]
    //     },
    //     {
    //         id: 'change-log',
    //         title: 'Change Log',
    //         icon: 'resilience-projects-dark-gray.png',
    //         options: [
    //             { id: 'change-log', label: 'Change Log', data: changeLog }
    //         ]
    //     }
    // ];

    const menuSections = [
        {
            id: 'property_details',
            title: 'Property Details',
            about: 'These help us build a more complete picture of the property physically',
            icon_dark: 'data-update-property-details-icon-dark.png',
            icon_light: 'data-update-property-details-icon-light.png',
            options: [
                { id: 'details', label: 'Characteristics / Structure', data: property_house_characteristics_structure },
                { id: 'condition', label: 'Materials', data: property_house_materials },
                { id: 'equipment', label: 'Equipment', data: property_house_equipment },
                { id: 'historical', label: 'Conditions', data: property_house_conditions }
            ]
        },
        {
            id: 'property_experiences',
            title: 'Property Experiences',
            about: 'These help us build a more complete picture of the property over time and how it has been used',
            icon_dark: 'data-update-property-experience-icon-dark.png',
            icon_light: 'data-update-property-experience-icon-light.png',
            options: [
                { id: 'details', label: 'History', data: property_house_history },
                { id: 'condition', label: 'Maintenance', data: property_house_maintenance },
                { id: 'historical', label: 'Usage', data: property_house_use }
            ]
        },
        {
            id: 'financial',
            title: 'Financial Details',
            about: 'These let you override our calculated assumptions and build your own intelligence into the analysis',
            icon_dark: 'data-update-financial-icon-dark.png',
            icon_light: 'data-update-financial-icon-light.png',
            options: [
                { id: 'area_economics', label: 'Area Economics', data: financial_area_economics },
                { id: 'current_costs', label: 'Current Costs + Trends', data: financial_current_costs },
                { id: 'housing_market', label: 'Housing Market', data: financial_housing_market }
            ]
        },
        {
            id: 'resilience',
            title: 'Resilience',
            about: "These ensure we are giving credit for resilience and don't recommend projects that you've already done",
            icon_dark: 'data-update-resilience-icon-dark.png',
            icon_light: 'data-update-resilience-icon-light.png',
            options: [
                { id: 'completed', label: 'Home Improvement Projects', data: enrichedProjects }
            ]
        },
        {
            id: 'change-log',
            title: "Past Updates You've Made",
            about: 'See all of the updates you have made and revert to past versions',
            icon_dark: 'data-update-change-log-icon-dark.png',
            icon_light: 'data-update-change-log-icon-light.png',
            options: [
                { id: 'change-log', label: 'Change History', data: changeLog }
            ]
        }
    ];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowUpdateModal(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [setShowUpdateModal]);

    const handleOptionClick = (sectionId, optionId) => {
        const section = menuSections.find(s => s.id === sectionId);
        const option = section.options.find(o => o.id === optionId);

        setSelectedSection(sectionId);
        setSelectedOption(optionId);
        setSelectedData(option.data);
    };

    const handleChangeClick = () => {
        setSelectedSection(null);
        setSelectedOption(null);
        setSelectedData(null);
        setSelectedHomeSection(null);
    };

    const handleDatapointChange = (datapointId, newValue) => {
        // Find the original datapoint either from selectedHomeSection or selectedData
        const originalDatapoint = selectedHomeSection
            ? selectedHomeSection.data.find(dp => dp.id === datapointId)
            : selectedData.find(dp => dp.id === datapointId);

        console.log('Original datapoint being changed:', originalDatapoint);

        // Normalize values for comparison
        const normalizedNewValue = newValue === '' ? null : newValue;
        const isRevertingToOriginal = originalDatapoint.datapoint_value === normalizedNewValue;

        if (selectedHomeSection) {
            // Update the selectedHomeSection data
            const updatedData = selectedHomeSection.data.map(datapoint =>
                datapoint.id === datapointId
                    ? { ...datapoint, datapoint_value_updated: isRevertingToOriginal ? null : normalizedNewValue }
                    : datapoint
            );

            setSelectedHomeSection({
                ...selectedHomeSection,
                data: updatedData
            });
        } else {
            // Update the selectedData directly
            setSelectedData(prev =>
                prev.map(datapoint =>
                    datapoint.id === datapointId
                        ? { ...datapoint, datapoint_value_updated: isRevertingToOriginal ? null : normalizedNewValue }
                        : datapoint
                )
            );
        }

        // Update the updatedDatapoints array
        if (isRevertingToOriginal) {
            setUpdatedDatapoints(prev => prev.filter(dp => dp.id !== datapointId));
        } else {
            setUpdatedDatapoints(prev => {
                const existingIndex = prev.findIndex(dp => dp.id === datapointId);
                console.log('Adding/updating datapoint in changes:', originalDatapoint);

                if (existingIndex >= 0) {
                    return prev.map(dp =>
                        dp.id === datapointId
                            ? { ...originalDatapoint, datapoint_value_updated: normalizedNewValue }
                            : dp
                    );
                } else {
                    return [...prev, { ...originalDatapoint, datapoint_value_updated: normalizedNewValue }];
                }
            });
        }
    };

    const removeChange = (id, type) => {
        if (type === 'project') {
            setUpdatedDatapoints(prev =>
                prev ? prev.filter(item => !(item.type_for_user_form === 'project' && item.project_id === id)) : []
            );
        } else {
            // Existing datapoint removal logic
            if (selectedHomeSection?.data) {
                const updatedData = selectedHomeSection.data.map(datapoint =>
                    datapoint.id === id
                        ? { ...datapoint, datapoint_value_updated: null }
                        : datapoint
                );
                setSelectedHomeSection({
                    ...selectedHomeSection,
                    data: updatedData
                });
            } else if (selectedData) {
                setSelectedData(prev =>
                    prev ? prev.map(datapoint =>
                        datapoint.id === id
                            ? { ...datapoint, datapoint_value_updated: null }
                            : datapoint
                    ) : []
                );
            }
            setUpdatedDatapoints(prev =>
                prev ? prev.filter(dp => dp.id !== id) : []
            );
        }
    };

    const handleMarkProjectCompleted = (project) => {
        console.log('HANDLER IS PROPERTY EXPLORER / UPDATE DATA MODULE');
        console.log('project THAT WAS CLICKED!!:', project);
        setUpdatedDatapoints(prev => {
            const existingIndex = prev.findIndex(item =>
                item.type_for_user_form === 'project' && item.project_id === project.project_id
            );

            if (existingIndex >= 0) {
                return prev.filter((_, index) => index !== existingIndex);
            } else {
                return [...prev, { ...project, completed: true }];
            }
        });
    };

    const handleUpdateAnalysis = async () => {
        setProcessingStatus(true);
        setShowUpdateModal(false);
        setShowProcessingModal(true);

        // Get user from localStorage
        const user = JSON.parse(localStorage.getItem('user') || '{}');

        // Transform datapoints into key-value pairs
        const userInputs = updatedDatapoints
            .filter(item => item.type_for_user_form === 'datapoint')
            .reduce((acc, item) => ({
                ...acc,
                [item.id]: item.datapoint_value_updated
            }), {});

        // Get list of completed project IDs
        const userCompletedProjects = updatedDatapoints
            .filter(item => item.type_for_user_form === 'project')
            .map(item => item.project_id);

        const updateBody = {
            address_id: property_id,
            user_id: user.user_id,
            user_inputs: userInputs,
            user_completed_projects: userCompletedProjects
        };

        console.log('updateBody:', updateBody);

        try {
            const response = await axios.post(
                `${import.meta.env.VITE_API_BASE_URL}/update-property-analysis`,
                updateBody
            );

            console.log(response)
            console.log(response.data)

            if (response.data.outcome === "PASS" && response.data.data) {
                console.log("API UPDATE SUCCESSFUL")
                console.log(response.data)

                // Set update status first
                setUpdateStatus(true);

                // Get the property change log and use an empty array if it doesn't exist
                const propertyChangeLog = response.data.change_log || [];

                // Then decompress and process the data
                const parsedData = decompressData(response.data.data);
                if (parsedData) {
                    
                    console.log('parsedData:', parsedData);
                    // Update local storage
                    const user = JSON.parse(localStorage.getItem('user'));
                    const updatedAddresses = user.purchased_addresses.map(addr => {
                        if (addr.address_id === property_id) {
                            return { ...addr, data: parsedData, change_log: propertyChangeLog };
                        }
                        return addr;
                    });
                    user.purchased_addresses = updatedAddresses;
                    localStorage.setItem('user', JSON.stringify(user));

                    // Find the updated property object from local storage
                    const updatedProperty = updatedAddresses.find(
                        addr => addr.address_id === property_id
                    );

                    // Finally update the property data
                    setPropertyData(updatedProperty);
                    setShowProcessingModal(false);
                    setProcessingComplete(true);
                }
            }
        } catch (error) {
            console.error('Error updating analysis:', error);
            if (error.response) {
                console.error('Error response:', error.response.data);
            }
        }
    };

    const intro_sentence = "When you make changes to the data and assumptions we re-run the analysis to give you the most accurate and up-to-date information. You can always revert to a previous version if you'd like!"

    // Add this helper function near the top of the component
    const mergeWithUpdatedDatapoints = (data) => {
        if (!Array.isArray(data)) return data;

        return data.map(datapoint => {
            const updatedDatapoint = updatedDatapoints.find(udp => udp.id === datapoint.id);
            if (updatedDatapoint) {
                return {
                    ...datapoint,
                    datapoint_value_updated: updatedDatapoint.datapoint_value_updated
                };
            }
            return datapoint;
        });
    };

    const renderHeader = (
        <div className="update-data-header-container">
            <div className="update-data-header">
                <h2 className="update-data-header-title">
                    Update Data and Assumptions
                </h2>
                <button
                    className="close-button"
                    onClick={() => setShowUpdateModal(false)}
                >
                    <CircleX size={32} strokeWidth={3} />
                </button>
            </div>
            {!selectedSection && updatedDatapoints.length === 0 && (
                <div className="update-data-intro-sentence-container">
                    <p className="update-data-intro-sentence text-align-center">
                        {intro_sentence}
                    </p>
                </div>
            )}
            {selectedSection &&
                <UpdateMenu
                    selectedSection={selectedSection}
                    selectedOption={selectedOption}
                    selectedHomeSection={selectedHomeSection}
                    setSelectedHomeSection={setSelectedHomeSection}
                    menuSections={menuSections}
                    handleOptionClick={handleOptionClick}
                    handleChangeClick={handleChangeClick}
                />
            }
        </div>
    );

    return (
        <div className="update-data-overlay">
            <div className="update-data-modal" ref={modalRef}>
                {renderHeader}
           
                <div className="update-data-layout">
                    <div className={`update-data-content ${updatedDatapoints.length > 0 ? 'update-data-content-with-selected-section' : ''}`}>
                        {!selectedSection &&
                            <UpdateMenu
                                selectedSection={selectedSection}
                                selectedOption={selectedOption}
                                selectedHomeSection={selectedHomeSection}
                                setSelectedHomeSection={setSelectedHomeSection}
                                menuSections={menuSections}
                                handleOptionClick={handleOptionClick}
                                handleChangeClick={handleChangeClick}
                            />
                        }

                        {selectedData && (
                            <>
                                {(selectedSection === 'property_details' || selectedSection === 'property_experiences') && (
                                    <>
                                        {selectedHomeSection ? (
                                            <InputsDisplay
                                                selectedData={mergeWithUpdatedDatapoints(selectedHomeSection.data)}
                                                inputsType="regular"
                                                handleDatapointChange={handleDatapointChange}
                                            />
                                        ) : (
                                            <PropertySubmenu
                                                selectedData={selectedData}
                                                onSectionSelect={setSelectedHomeSection}
                                            />
                                        )}
                                    </>
                                )}

                                {selectedSection === 'financial' && (
                                    <InputsDisplay
                                        selectedData={mergeWithUpdatedDatapoints(selectedData)}
                                        inputsType="regular"
                                        handleDatapointChange={handleDatapointChange}
                                    />
                                )}

                                {selectedSection === 'resilience' && (
                                    <InputsDisplay
                                        projects={enrichedProjects}
                                        inputsType="projects"
                                        handleMarkProjectCompleted={handleMarkProjectCompleted}
                                    />
                                )}

                                {selectedSection === 'change-log' && (
                                    <ChangeLog changeLog={changeLog} menuSections={menuSections} />
                                )}
                            </>
                        )}
                    </div>
                    {updatedDatapoints.length > 0 && (
                        <Sidebar
                            updatedDatapoints={updatedDatapoints}
                            removeChange={removeChange}
                            handleUpdateAnalysis={handleUpdateAnalysis}
                            processingStatus={processingStatus}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default UpdateDataModule;
